// Intentionally memory-only: survives SPA navigation, never a browser refresh.
// Kept separate from persisted wallet/history and resettable live statistics.
const recentByOwner = new Map();

export const recordSessionRecentBet = (owner, round) => {
  if (round?.game !== 'limbo' || !round.finished) return;
  const current = recentByOwner.get(owner) || [];
  recentByOwner.set(owner, [...current.filter((item) => item.request_id !== round.request_id), round].slice(-100));
};

export const getSessionRecentBets = (owner) => recentByOwner.get(owner) || [];
export const clearSessionRecentBets = (owner) => recentByOwner.delete(owner);